import { observer } from 'mobx-react-lite';
import { Layout, Button } from 'Components';
import { useStores } from 'Hooks/useStore';
import { DashboardTabKey } from 'Services/Api/Dashboard/Types';
import { MyResultsWidgets } from 'Pages/Dashboard/tabs/MyResults/MyResults.types';
import { OpenInNewTab } from 'Pages/Dashboard/components';
import styles from './Courses.module.scss';
import { useTranslation } from 'react-i18next';

function Courses() {
    const stores = useStores();
    const { t } = useTranslation();
    const { systemsStore, authStore } = stores;
    const isSuperAdmin = authStore.isCurrentUserSuperAdmin;

    return (
        <Layout className={styles.root}>
            <h1 className={styles.header}>{t('courses.quickLinks')}</h1>
            <div className={styles.card}>
                <h3 className={styles.title}>{t('courses.myCourses')}</h3>
                <OpenInNewTab
                    tab={DashboardTabKey.MyResults}
                    widget={MyResultsWidgets.MyCourses}
                    tenantId={isSuperAdmin ? null : systemsStore.selectedTenant.value}
                    tooltipPlacement="top"
                    button={(handleButtonClick) => (
                        <Button
                            onClick={handleButtonClick}
                            shape="round"
                            type="primary"
                            className={`${styles.btn} cta-prominent`}>{t('courses.coursesBtn')}</Button>
                    )}
                />
            </div>
        </Layout>
    );
}

export default observer(Courses);